import EditIcon from "@mui/icons-material/Edit";
import { IconButton } from "@mui/material";
import React, { useEffect } from "react";
import { updateSubscription } from "../../../../../services/subscriptions.service";

import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import { ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { ModalComponent } from "../../../../../ui-components/Modal";
import {
  adminButtonOutlinedSx,
  adminButtonPrimarySx,
} from "../../../modalStyle";

// Removendo estilo fixo para adotar modal padronizado do Admin

interface PreSubscription {
  id: number;
  user_id: number;
  event_id: number;
  first_time: boolean;
  start_date: Date;
  end_date: Date;
  status_id: number;
  created_at: Date;
}

export default function UpdateButton({
  id,
  updateSubscriptions,
  sub,
}: {
  id: number;
  updateSubscriptions: Function;
  sub: PreSubscription;
}) {
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [status, setStatus] = React.useState<number>(sub.status_id);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const formData: any = { status_id: status };
    updateSubscription(formData, id);
    handleClose();
    updateSubscriptions();
  };

  useEffect(() => {
    updateSubscriptions();
    return () => {
      updateSubscriptions();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <>
      <ModalComponent
        open={open}
        handleClose={handleClose}
        title="Editar Pré-inscrição"
        maxWidth={isMobile ? "90%" : 600}
        autoHeight
      >
        <form onSubmit={handleSubmit}>
          <Box>
            <Typography variant="body2" sx={{ color: "#24324D", mb: 1 }}>
              Status da Pré-inscrição
            </Typography>
            <ToggleButtonGroup
              color="primary"
              exclusive
              value={status}
              onChange={(_, val) => {
                if (val !== null) setStatus(val);
              }}
              fullWidth
              orientation={isMobile ? "vertical" : "horizontal"}
              size={isMobile ? "small" : "medium"}
              sx={{
                display: "flex",
                gap: 2,
                flexDirection: isMobile ? "column" : "row",
                "& .MuiToggleButton-root": {
                  flex: 1,
                  width: "100%",
                  textTransform: "none",
                  justifyContent: "flex-start",
                  padding: isMobile ? "10px 12px" : undefined,
                  borderRadius: isMobile ? 2 : 2,
                  gap: 1,
                },
                "& .Mui-selected": {
                  backgroundColor: "#eef2ff",
                  borderColor: "primary.main",
                  border: "0.5 0.5 0.5 0.5",
                },
              }}
            >
              <ToggleButton value={0} aria-label="Em Análise">
                <HourglassEmptyIcon fontSize="small" /> Em Análise
              </ToggleButton>
              <ToggleButton value={1} aria-label="Aceito">
                <CheckCircleIcon fontSize="small" color="success" /> Aceito
              </ToggleButton>
              <ToggleButton value={2} aria-label="Recusado">
                <CancelIcon fontSize="small" color="error" /> Recusado
              </ToggleButton>
            </ToggleButtonGroup>
            <Box
              sx={{
                mt: 3,
                borderTop: "1px solid",
                borderColor: "divider",
                display: "flex",
                pt: 1,
                flexDirection: isMobile ? "column" : "row-reverse",
                justifyContent: isMobile ? "flex-end" : "flex-start",
                gap: 2,
              }}
            >
              <Button
                variant="contained"
                type="submit"
                sx={adminButtonPrimarySx}
                fullWidth={isMobile}
              >
                Alterar
              </Button>
              <Button
                onClick={handleClose}
                sx={adminButtonOutlinedSx}
                fullWidth={isMobile}
              >
                Cancelar
              </Button>
            </Box>
          </Box>
        </form>
      </ModalComponent>
      <IconButton
        onClick={() => {
          handleOpen();
          updateSubscriptions();
        }}
      >
        <EditIcon />
      </IconButton>
    </>
  );
}
